
import WpImage from '~/components/ui/img.vue';

export default {
  name: 'GalleryItem',

  components: {
    WpImage,
  },

  props: {
    text: {
      type: String,
      required: true,
    },
    image: {
      type: Object,
      default: null,
    },
  },
};
